const parent = document.querySelector('.voomct-rotating-hero');
const slides = document.querySelectorAll( '.voomct-rotating-hero-slide' );
const title  = document.querySelector('.voomct-rotating-hero h1');
const delay  = 6000;

let counter  = 0;
let activeSlide = null;
let words = null;


/**
 *
 *
 *
 */
const init = function () {

	if ( slides.length > 0 ) {

		setTimeout( () => {
			parent.classList.add('is-initialized');
			startRotation();
		}, 1500 );

	}

};


/**
 *
 *
 *
 */
const setupKeywords = function() {

	if ( title.hasAttribute('data-voomct-rotation-text') ) {

		words = JSON.parse( title.getAttribute('data-voomct-rotation-text') );

		// setup keywords
		words.forEach( ( word ) => {
			const slot = title.querySelector('.voomct-rotating-hero__keyword-slot');
			const span = document.createElement('span');
			span.setAttribute('class','voomct-rotating-hero-keyword')
			span.setAttribute('aria-hidden','true')
			span.innerText = word;
			title.insertBefore(span, slot);
			words = document.querySelectorAll('.voomct-rotating-hero-keyword');
		} );

		// make last word visible first
		words[words.length - 1].setAttribute('aria-hidden','false');

	}

}


/**
 *
 *
 *
 */
const rotateWord = function() {

	const wordIndex = ( counter > 0 ) ? ( counter - 1 ) : ( words.length - 1 );

	words[wordIndex].setAttribute('aria-hidden','false');

	words.forEach( ( element ) => {
		if ( element != words[wordIndex] ) {
			element.setAttribute('aria-hidden','true');
		}
	} );

}


/**
 *
 *
 *
 */
const startRotation = function() {

	counter = slides.length - 1;

	setupKeywords();

	setInterval( () => {

		activeSlide = slides[counter];
		rotateWord();

		// advance slide
		if ( counter > 0 ) {

			activeSlide.classList.add('is-hidden');
			counter--;

		// reset slides
		} else if ( counter <= 0 ) {

			slides.forEach( ( element ) => {
				element.classList.remove('is-hidden');
			} );

			counter = slides.length - 1;

		}

	}, delay);

}


/**
 *
 *
 *
 */
const api = {
	init: init
};

export default api;
